import { IProductService } from '../IProductService';
import { MockedSolarPanelService } from './MockedSolarPanelService';
import { Product } from '@/types';

export class SolarPanelServiceFactory {
    public static create(): IProductService<Product> {
        return new MockedSolarPanelService();
    }
}
